"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostOrderCreate = void 0;
const Base_1 = require("./Base");
exports.PostOrderCreate = {
    url: Base_1.URL_BASE + "/create",
    method: "POST",
    secure: false
};
//# sourceMappingURL=PostOrderCreate.js.map